import { AppStoreButtons } from '../../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Heading } from '../../../../components/Heading/Heading';
import { QRCode } from '../../../../components/QRCode/QRCode';
import { Text } from '../../../../components/Text/Text';

export const NoReviewsCTASection = () => {
  return (
    <div className="bg-lake-fog flex flex-col items-center justify-center gap-6 rounded-xl p-6 md:flex-row">
      <div className="flex w-full flex-col items-center justify-center gap-2 text-center sm:w-1/2 md:w-full md:items-start md:text-left">
        <Heading variant="xs" as="p" className="m-0">
          No written reviews yet
        </Heading>
        <Text variant="sm" as="p" className="m-0">
          Help anglers know what to expect, add your review in the Fishbrain app.
        </Text>
      </div>
      <div className="flex w-full items-center justify-center md:hidden">
        <AppStoreButtons orientation="vertical" source="NoReviewsCTASection" />
      </div>
      <QRCode
        size={140}
        imageSize={35}
        className="hidden w-full sm:hidden md:flex md:justify-end"
        source="AppDownloadModal"
      />
    </div>
  );
};
